import axios from 'axios'
const getCep = cep => {
    return fetch( `https://viacep.com.br/ws/${cep}/json/` ).then( r => r.json() )
}
export default getCep



// WEBPACK FOOTER //
// ./src/helpers/GetCep.js